// @flow
import React from 'react';
import { Button, Card, Cell, FileUpload, CardActions } from 'react-md';
import Papa from 'papaparse';
import cn from 'classnames';

type errorType = {
  type: string,
  code: string,
  message: string,
  row: number
}
export type csvType = Array<{[string]: string}>
export type csvData = { data: csvType, errors: Array<errorType> }

type Props = {
  type: string,
  upload: (any) => void,
  tr: any,
  translationKeys: {
    fileAborted:string,
    importName:string,
    fileSelect: string,
    next: string,
    importDescription: string
  },
  onClick: () => void,
  disabled: boolean,
}

const papaConfig = {
  delimiter: '',
  newline: '',
  quoteChar: '\'',
  header: true,
};

export function UploadViewer(props: Props) {
  const error: boolean = props[props.type].errors && props[props.type].errors.length > 0;
  const { fileAborted, importName, importDescription, fileSelect, next } = props.translationKeys;
  return (
    <div className={'md-grid md-grid--maxwidth'}>
      <Card
        className={cn(' pwa-card-form', Cell.getClassName({ size: 12, phoneSize: 4 }))}
      >
        <div className={'h-align--center '}>
          <h1 className={'md-heading-2'}>{props.tr(importName)}</h1>
          <p className={'h-pb--medium'}>{props.tr(importDescription)}</p>
          <FileUpload
            accept=".csv,.txt,.CSV,.TXT"
            id="upload"
            required
            label={props.tr(fileSelect)}
            onLoad={(file: File, result: string) => props.upload(Papa.parse(result, papaConfig))}
          />
          <div className="md-text-field-message-container md-full-width md-text--error u-pt--half">
            <div aria-hidden="false" className="md-text-field-message md-text-field-message--active">
              {error ? props.tr(fileAborted) : ''}
            </div>
          </div>
        </div>
        <CardActions className={'h-flex--end'}>
          <Button
            raised
            secondary
            disabled={props.disabled}
            onClick={props.onClick}
          >{props.tr(next)}</Button>
        </CardActions>
      </Card>
    </div>
  );
}
